import { trpc } from '@/shared/api';

/** 인쇄 방식 목록 캐시 무효화 함수를 돌려준다. */
export const useInvalidatePrintMethods = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => void utils.productManagement.printMethods.list.invalidate();
};
